import { put, takeLatest } from 'redux-saga/effects';
import { SpaceAPI } from 'api/space/space';
import { FetchStatus } from 'data/core';
import { saveSpaceTabs, addSpaceTab } from 'data/space-tabs';
import { fetchSpaceDetailSagaAction } from '../actions';
import { fetchDetailStart, fetchDetailSuccess, fetchDetailFailure } from '../index';
function* fetchSpaceDetailSaga(action) {
    const { payload } = action;
    try {
        yield put(fetchDetailStart(payload));
        const data = yield SpaceAPI.getSpaceDetail(payload);
        if (data.spaceTabs.length > 0) {
            yield put(saveSpaceTabs({
                data: data.spaceTabs,
                fetchStatus: FetchStatus.Partial
            }));
        } else {
            /* Show empty tab */ yield put(addSpaceTab({
                spaceTabId: 'new',
                space: {
                    spaceId: payload
                }
            }));
        }
        yield put(fetchDetailSuccess(data));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        yield put(fetchDetailFailure());
    }
}
export function* watchFetchSpaceDetailSaga() {
    yield takeLatest(fetchSpaceDetailSagaAction.type, fetchSpaceDetailSaga);
}
